import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-trident-gray-50 p-4">
      <div className="card text-center max-w-md animate-fade-in">
        <img src="/trident-logo.png" alt="itTrident" className="h-10 mx-auto mb-6" />
        <h1 className="font-display font-extrabold text-7xl text-trident-orange mb-2 tracking-tight">404</h1>
        <h2 className="font-display font-bold text-xl text-trident-gray-900 mb-2">Page not found</h2>
        <p className="text-sm text-trident-gray-500 mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn-primary inline-flex items-center gap-2">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
